var _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlockedCameraIcon = function SvgBlockedCameraIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "blocked-camera-icon_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 10.5V0H0v21h20.25v-.438A1.991 1.991 0 0 1 19 21h-8.5v-8.5a2 2 0 0 1 2-2h7.75Z",
    fill: "#5A5A5A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#blocked-camera-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9V5.5c0-.55-.45-1-1-1h-12c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V12l4 4V5l-4 4Z",
    fill: "#000"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12H14a2 2 0 0 0-2 2v6.5a2 2 0 0 0 2 2h6.5a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2Z",
    fill: "#DB4437"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m17.25 18.04-2.046 2.046a.56.56 0 0 1-.79-.79l2.046-2.046-2.046-2.046a.56.56 0 0 1 .79-.79l2.046 2.046 2.046-2.046a.559.559 0 0 1 .79.79L18.04 17.25l2.046 2.046a.559.559 0 0 1-.79.79L17.25 18.04Z",
    fill: "#fff"
  })));
};
export default SvgBlockedCameraIcon;